import { useEffect, useMemo, useState } from "react";
import axios from "axios";


import {
  FiDownload,
  FiEdit3,
  FiX,
  FiUser,
  FiMail,
  FiBook,
  FiHeart,
  FiMessageCircle,
  FiCamera,
  FiCheck,
  FiCalendar,
  FiImage,
  FiSend,
  FiMoreHorizontal,
  FiTrash2,
  FiAward,
  FiArrowLeft,
  FiUsers,
  FiUserCheck,
  FiSearch,
  FiFilter,
  FiChevronDown,
  FiCheckCircle,
  FiUpload,
  FiEye,
} from "react-icons/fi";


import * as XLSX from "xlsx";

import "./studentsFaculty.css";

axios.defaults.withCredentials = true;

const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.yearbookhub.online";

function StudentsFaculty() {
  const [people, setPeople] = useState([]);
  const [search, setSearch] = useState("");
 const [filterDepartment, setFilterDepartment] = useState("All");
  const [loading, setLoading] = useState(true);
const [showAwardsPage, setShowAwardsPage] = useState(false);
  const [importing, setImporting] = useState(false);
const [showAwardsPanel, setShowAwardsPanel] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
const [awardCategory, setAwardCategory] = useState("latin_honors");
const [selectedAward, setSelectedAward] = useState("All");
const [awardSearch, setAwardSearch] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  /* =========================================================
     FETCH REGISTRAR RECORDS
  ========================================================= */

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_URL}/api/admin/users`, {
        withCredentials: true,
      });


console.log("Registrar records:", res.data);

setPeople(Array.isArray(res.data) ? res.data : []);

    } catch (err) {
      console.error("Failed to fetch registrar records:", err);

      alert(
        err.response?.data?.message ||
          "Failed to load students and faculty."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  /* =========================================================
     EXCEL IMPORT
  ========================================================= */

  const handleExcelImport = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();

    if (![".xlsx", ".xls"].includes(extension)) {
      alert("Please select an Excel file (.xlsx or .xls).");
      event.target.value = "";
      return;
    }

    try {
      setImporting(true);

      const formData = new FormData();

      formData.append("file", file);

      const res = await axios.post(
        `${API_URL}/api/admin/users/import-excel`,
        formData,
        {
          withCredentials: true,
        }
      );

      console.log("Excel import result:", res.data);

const inserted = res.data.inserted || 0;
const updated = res.data.updated || 0;
const skipped = res.data.skipped || 0;
const errors = res.data.errors || [];

let message =
  `${res.data.message || "Excel import completed."}\n\n` +
  `New records: ${inserted}\n` +
  `Updated records: ${updated}\n` +
  `Skipped/failed rows: ${skipped}`;

if (errors.length > 0) {
  message += `\n\nDetails:\n${errors.slice(0, 10).join("\n")}`;

  if (errors.length > 10) {
    message += `\n...and ${errors.length - 10} more errors.`;
  }
}

alert(message);
await fetchUsers();
    } catch (err) {
      console.error("Excel import failed:", err);

      alert(
        err.response?.data?.message ||
          "Failed to import Excel file. Please try again."
      );
    } finally {
      setImporting(false);

      event.target.value = "";
    }
  };

  const handleExcelExport = () => {
  try {
    const students = people
      .filter(
        (person) => person.role?.toLowerCase() === "student"
      )
      .sort(sortByName);

    const faculty = people
      .filter(
        (person) => person.role?.toLowerCase() === "faculty"
      )
      .sort(sortByName);

    const formatPerson = (person) => ({
      "Full Name": person.full_name || "",
      Email: person.email || "",
      Program: person.department_program || "",
      Department: getDepartment(person) || "",
      Role: person.role || "",
      Position: person.position || "",
      Batch: person.batch || "",
      "Batch Name": person.batch_name || "",
      "Latin Honors": person.latin_honors || "Graduated",
"Academic Awards": person.academic_awards || "Graduated",
"Special Awards": person.special_awards || "Graduated",
"Graduation Status": person.graduation_status || "Graduated",

    });

    const workbook = XLSX.utils.book_new();

    const allRecords = [...students, ...faculty].sort(sortByName);

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(allRecords.map(formatPerson)),
      "All Records"
    );

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(students.map(formatPerson)),
      "Students"
    );

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(faculty.map(formatPerson)),
      "Faculty"
    );

    XLSX.writeFile(
      workbook,
      `ADSSU_Students_Faculty_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  } catch (error) {
    console.error("Excel export failed:", error);
    alert("Failed to export Excel file. Please try again.");
  }
};

const getDepartment = (person) => {
  const role = person.role?.toLowerCase();

  if (role === "faculty") {
    return (
      person.department?.trim() ||
      person.department_program?.trim() ||
      ""
    );
  }

  return person.department?.trim() || "";
};

const departments = useMemo(() => {
  return [
    ...new Set(
      people
        .map((person) => getDepartment(person))
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b));
}, [people]);

const filtered = useMemo(() => {
  return people.filter((person) => {
    const searchValue = search.toLowerCase().trim();
    const department = getDepartment(person);

    const matchSearch =
      person.full_name?.toLowerCase().includes(searchValue) ||
      person.email?.toLowerCase().includes(searchValue) ||
      person.department_program?.toLowerCase().includes(searchValue) ||
      person.department?.toLowerCase().includes(searchValue);

    const matchDepartment =
      filterDepartment === "All" ||
      department === filterDepartment;

    return matchSearch && matchDepartment;
  });
}, [people, search, filterDepartment]);


const sortByName = (a, b) => {
  const getSurname = (name) =>
    (name || "")
      .trim()
      .split(/\s+/)
      .pop()
      .toLocaleLowerCase();

  const surnameA = getSurname(a.full_name);
  const surnameB = getSurname(b.full_name);

  return (
    surnameA.localeCompare(surnameB) ||
    (a.full_name || "").localeCompare(
      b.full_name || "",
      undefined,
      { sensitivity: "base" }
    )
  );
};

const filteredStudents = filtered
  .filter((person) => person.role?.toLowerCase() === "student")
  .sort(sortByName);

const filteredFaculty = filtered
  .filter((person) => person.role?.toLowerCase() === "faculty")
  .sort(sortByName);

  // =========================================================
// AWARDS DIRECTORY
// =========================================================

const awardCategories = [
  { value: "latin_honors", label: "Latin Honors" },
  { value: "academic_awards", label: "Academic Awards" },
  { value: "special_awards", label: "Special Awards" },
];

// Treat empty/default values as no award.
const getAwards = (value) => {
  if (!value) return [];

  return String(value)
    .split(/[;\n|]+/)
    .map((award) => award.trim())
    .filter(
      (award) =>
        award &&
        ![
          "graduated",
          "none",
          "no award",
          "n/a",
          "null",
          "undefined",
        ].includes(award.toLowerCase())
    );
};

// Only include students who actually have awards.
const studentsWithAwards = useMemo(() => {
  return people
    .filter(
      (person) => person.role?.toLowerCase() === "student"
    )
    .flatMap((person) => {
      const awards = getAwards(person[awardCategory]);

      return awards.map((award) => ({
        ...person,
        award,
      }));
    });
}, [people, awardCategory]);

// Build the dropdown from the imported award values.
const availableAwards = useMemo(() => {
  return [
    ...new Set(
      studentsWithAwards.map((person) => person.award)
    ),
  ].sort((a, b) => a.localeCompare(b));
}, [studentsWithAwards]);

// Filter by award and student name.
const awardResults = useMemo(() => {
  const searchValue = awardSearch.trim().toLowerCase();

  return studentsWithAwards
    .filter((person) => {
      const matchesAward =
        selectedAward === "All" ||
        person.award.toLowerCase() ===
          selectedAward.toLowerCase();

      const matchesSearch =
        !searchValue ||
        person.full_name?.toLowerCase().includes(searchValue) ||
        person.email?.toLowerCase().includes(searchValue) ||
        person.award.toLowerCase().includes(searchValue);

      return matchesAward && matchesSearch;
    })
    .sort(sortByName);
}, [
  studentsWithAwards,
  selectedAward,
  awardSearch,
]);

  /* =========================================================
     COUNTS
  ========================================================= */

  const studentCount = people.filter(
    (person) =>
      person.role?.toLowerCase() === "student"
  ).length;

  const facultyCount = people.filter(
    (person) =>
      person.role?.toLowerCase() === "faculty"
  ).length;


  /* =========================================================
     HELPERS
  ========================================================= */

  const getInitials = (name) => {
    if (!name) return "U";

    return name
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const getProfileImage = (profilePic) => {
    if (!profilePic) return null;

    if (
      profilePic.startsWith("http://") ||
      profilePic.startsWith("https://")
    ) {
      return profilePic;
    }

    return `${API_URL}${
      profilePic.startsWith("/")
        ? profilePic
        : `/${profilePic}`
    }`;
  };

  /* =========================================================
     DELETE
  ========================================================= */

const handleDeleteUser = async () => {
  if (!selectedPerson) return;

  try {
    setDeleting(true);

    if (selectedPerson.user_id) {
      // Activated account: use the existing full account deletion.
      await axios.delete(
        `${API_URL}/api/admin/users/${selectedPerson.user_id}`,
        { withCredentials: true }
      );
    } else {
      // Not activated: delete only the registrar record.
      const registrarId =
        selectedPerson.registrar_id ?? selectedPerson.id;

      if (!registrarId) {
        throw new Error("Registrar record ID is missing.");
      }

      await axios.delete(
        `${API_URL}/api/admin/registrar-records/${registrarId}`,
        { withCredentials: true }
      );
    }

    await fetchUsers();

    setShowDeleteConfirm(false);
    setSelectedPerson(null);

    alert(
      selectedPerson.user_id
        ? "User account and associated records deleted successfully."
        : "Unactivated registrar record deleted successfully."
    );
  } catch (err) {
    console.error("Failed to delete record:", err);

    alert(
      err.response?.data?.message ||
        err.message ||
        "Failed to delete record. Please try again."
    );
  } finally {
    setDeleting(false);
  }
};

if (showAwardsPage) {
  return (
    <div className="sf-container sf-awards-page">
      <header className="sf-header">
        <div className="sf-header-left">
          <button
            type="button"
            className="sf-back-btn"
            onClick={() => setShowAwardsPage(false)}
          >
            <FiArrowLeft />
            Back to Students & Faculty
          </button>

          <div>
            <span className="sf-eyebrow">STUDENT DIRECTORY</span>
            <h1>Student Awards</h1>
            <p>
              Browse graduating students by honors and awards.
            </p>
          </div>
        </div>

        <div className="sf-header-count">
          <strong>{studentsWithAwards.length}</strong>
          <span>Award Entries</span>
        </div>
      </header>

      <section className="sf-table-card">
        <div className="sf-awards-filters">
          <div className="sf-award-field">
            <label htmlFor="award-category">Award Category</label>
            <select
              id="award-category"
              value={awardCategory}
              onChange={(e) => {
                setAwardCategory(e.target.value);
                setSelectedAward("All");
                setAwardSearch("");
              }}
            >
              {awardCategories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>

          <div className="sf-award-field">
            <label htmlFor="specific-award">Specific Award</label>
            <select
              id="specific-award"
              value={selectedAward}
              onChange={(e) => setSelectedAward(e.target.value)}
            >
              <option value="All">All Awards</option>
              {availableAwards.map((award) => (
                <option key={award} value={award}>
                  {award}
                </option>
              ))}
            </select>
          </div>

          <div className="sf-award-field">
            <label htmlFor="award-search">Search</label>
            <input
              id="award-search"
              type="search"
              placeholder="Search student or award..."
              value={awardSearch}
              onChange={(e) => setAwardSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="sf-table-wrapper">
          <table className="sf-table">
            <thead>
              <tr>
                <th>STUDENT NAME</th>
                <th>EMAIL</th>
                <th>PROGRAM</th>
                <th>AWARD CATEGORY</th>
                <th>AWARD</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="sf-loading">
                    Loading awards...
                  </td>
                </tr>
              ) : awardResults.length > 0 ? (
                awardResults.map((person, index) => (
                  <tr
                    key={`${person.registrar_id ?? person.id}-${person.award}-${index}`}
                  >
                    <td>{person.full_name || "Unnamed Student"}</td>
                    <td>{person.email || "—"}</td>
                    <td>
                      {person.department_program || "Not specified"}
                    </td>
                    <td>
                      {awardCategories.find(
                        (category) => category.value === awardCategory
                      )?.label}
                    </td>
                    <td>
                      <span className="sf-award-name">
                        {person.award}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="sf-empty">
                    No award recipients found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="sf-container">

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <header className="sf-header">

        <div className="sf-header-left">

          <div className="sf-header-icon">
            <FiUsers />
          </div>

          <div>
            <span className="sf-eyebrow">
              USER MANAGEMENT
            </span>

            <h1>
              Students & Faculty
            </h1>

            <p>
              Manage everyone featured in the
              ADSSU digital yearbook.
            </p>
          </div>

        </div>

        <div className="sf-header-count">

          <strong>
            {people.length}
          </strong>

          <span>
            Total Records
          </span>

        </div>

      </header>


      {/* =====================================================
          SUMMARY
      ===================================================== */}

      <section className="sf-summary">

        <div className="sf-summary-card">

          <div className="sf-summary-icon students">
            <FiUsers />
          </div>

          <div>

            <span>
              Students
            </span>

            <strong>
              {studentCount.toLocaleString()}
            </strong>

          </div>

        </div>


        <div className="sf-summary-card">

          <div className="sf-summary-icon faculty">
            <FiUserCheck />
          </div>

          <div>

            <span>
              Faculty
            </span>

            <strong>
              {facultyCount.toLocaleString()}
            </strong>

          </div>

        </div>


       


        <div className="sf-summary-card">

          <div className="sf-summary-icon total">
            <FiUsers />
          </div>

          <div>

            <span>
              All Records
            </span>

            <strong>
              {people.length.toLocaleString()}
            </strong>

          </div>

        </div>

      </section>


      {/* =====================================================
          TOOLBAR
      ===================================================== */}

      <section className="sf-toolbar">

        <div className="sf-search">

          <FiSearch />

          <input
            type="text"
            placeholder="Search name, email, or program..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

          {search && (
            <button
              type="button"
              className="sf-clear"
              onClick={() => setSearch("")}
            >
              �
            </button>
          )}

        </div>



<div className="sf-filter">
  <FiFilter />

  <select
    value={filterDepartment}
    onChange={(e) => setFilterDepartment(e.target.value)}
  >
    <option value="All">All Departments</option>

    {departments.map((department) => (
      <option key={department} value={department}>
        {department}
      </option>
    ))}
  </select>

  <FiChevronDown className="sf-filter-arrow" />
</div>




<div className="sf-import-actions">
  <div className="sf-import">

    <button
  type="button"
  className="sf-awards-page-btn"
  onClick={() => {
    setSelectedAward("All");
    setAwardSearch("");
    setShowAwardsPage(true);
  }}
>
  <FiCheckCircle />
  Student Awards
 
</button>
    <input
      type="file"
      id="excel-import"
      accept=".xlsx,.xls"
      onChange={handleExcelImport}
      disabled={importing}
      hidden
    />

    <label
      htmlFor="excel-import"
      className={`sf-import-btn ${
        importing ? "importing" : ""
      }`}
    >
      <FiUpload />
      {importing ? "Importing..." : "Import Excel"}
    </label>
  </div>

  <button
    type="button"
    className="sf-export-btn"
    onClick={handleExcelExport}
    disabled={loading || people.length === 0}
  >
    <FiDownload />
    Export Excel
  </button>
</div>



        <div className="sf-result-count">

          <strong>
            {filtered.length}
          </strong>

          <span>
            {filtered.length === 1
              ? "record"
              : "records"}{" "}
            found
          </span>

        </div>

      </section>

{/* STUDENTS TABLE */}
<section className="sf-table-card">
  <div className="sf-table-header">
    <div>
      <span className="sf-table-eyebrow">STUDENT DIRECTORY</span>
      <h2>Students</h2>
    </div>
    <span className="sf-table-total">
      {filteredStudents.length} students
    </span>
  </div>

  <div className="sf-table-wrapper">
    <table className="sf-table">
      <thead>
        <tr>
          <th>NAME</th>
          <th>EMAIL</th>
          <th>PROGRAM</th>
          <th>DEPARTMENT</th>
          <th>ROLE</th>
          <th>ACTIONS</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
            <td colSpan={6} className="sf-loading">
              <div className="loading-spinner" />
              <span>Loading students...</span>
            </td>
          </tr>
        ) : filteredStudents.length > 0 ? (
          filteredStudents.map((person) => (
            <tr key={person.registrar_id ?? person.id}>
              <td className="name-cell">
                <div className="sf-user">
                  <div className="sf-avatar">
                    {getProfileImage(person.profile_pic) ? (
                      <img
                        src={getProfileImage(person.profile_pic)}
                        alt={person.full_name || "Student"}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                          const fallback =
                            e.currentTarget.parentElement?.querySelector(
                              ".sf-avatar-fallback"
                            );
                          if (fallback) fallback.style.display = "flex";
                        }}
                      />
                    ) : null}

                    <div
                      className="sf-avatar-fallback"
                      style={{
                        display: getProfileImage(person.profile_pic)
                          ? "none"
                          : "flex",
                      }}
                    >
                      {getInitials(person.full_name)}
                    </div>
                  </div>

                  <div className="sf-name">
                    <strong>{person.full_name || "Unnamed User"}</strong>
                    <span>Student</span>
                  </div>
                </div>
              </td>

              <td>
                <div className="sf-email">
                  <FiMail />
                  <span>{person.email || "—"}</span>
                </div>
              </td>

              <td>
                <div className="sf-department">
                  {person.department_program || "Program not specified"}
                </div>
              </td>

              <td>
                <div className="sf-department">
                  {person.department || "Department not specified"}
                </div>
              </td>

              <td>
                <span className="sf-role student">
                  <span className="sf-role-dot" />
                  Student
                </span>
              </td>

              <td>
                <button
                  type="button"
                  className="sf-view-btn"
                  onClick={() => {
                    setSelectedPerson(person);
                    setShowDeleteConfirm(false);
                  }}
                >
                  <FiEye />
                  View Details
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={6} className="sf-empty">
              <div className="sf-empty-icon">
                <FiUsers />
              </div>
              <strong>No students found</strong>
              <span>Try changing your search or role filter.</span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</section>

{/* FACULTY TABLE */}
<section className="sf-table-card">
  <div className="sf-table-header">
    <div>
      <span className="sf-table-eyebrow">FACULTY DIRECTORY</span>
      <h2>Faculty</h2>
    </div>
    <span className="sf-table-total">
      {filteredFaculty.length} faculty members
    </span>
  </div>

  <div className="sf-table-wrapper">
    <table className="sf-table">
      <thead>
        <tr>
          <th>NAME</th>
          <th>EMAIL</th>
          <th>DEPARTMENT</th>
          <th>ROLE</th>
          <th>ACTIONS</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
            <td colSpan={5} className="sf-loading">
              <div className="loading-spinner" />
              <span>Loading faculty...</span>
            </td>
          </tr>
        ) : filteredFaculty.length > 0 ? (
          filteredFaculty.map((person) => (
            <tr key={person.registrar_id ?? person.id}>
              <td className="name-cell">
                <div className="sf-user">
                  <div className="sf-avatar">
                    {getProfileImage(person.profile_pic) ? (
                      <img
                        src={getProfileImage(person.profile_pic)}
                        alt={person.full_name || "Faculty"}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                          const fallback =
                            e.currentTarget.parentElement?.querySelector(
                              ".sf-avatar-fallback"
                            );
                          if (fallback) fallback.style.display = "flex";
                        }}
                      />
                    ) : null}

                    <div
                      className="sf-avatar-fallback"
                      style={{
                        display: getProfileImage(person.profile_pic)
                          ? "none"
                          : "flex",
                      }}
                    >
                      {getInitials(person.full_name)}
                    </div>
                  </div>

                  <div className="sf-name">
                    <strong>{person.full_name || "Unnamed User"}</strong>
                    <span>Faculty Member</span>
                  </div>
                </div>
              </td>

              <td>
                <div className="sf-email">
                  <FiMail />
                  <span>{person.email || "—"}</span>
                </div>
              </td>

              <td>
                <div className="sf-department">
                  {person.department || person.department_program ||
                    "Department not specified"}
                </div>
              </td>

              <td>
                <span className="sf-role faculty">
                  <span className="sf-role-dot" />
                  Faculty
                </span>
              </td>

              <td>
                <button
                  type="button"
                  className="sf-view-btn"
                  onClick={() => {
                    setSelectedPerson(person);
                    setShowDeleteConfirm(false);
                  }}
                >
                  <FiEye />
                  View Details
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5} className="sf-empty">
              <div className="sf-empty-icon">
                <FiUsers />
              </div>
              <strong>No faculty found</strong>
              <span>Try changing your search or role filter.</span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</section>



      {/* =====================================================
          DETAILS MODAL
      ===================================================== */}

      {selectedPerson && (

        <div
          className="sf-modal-overlay"
          onClick={() => {

            if (!deleting) {

              setSelectedPerson(null);
              setShowDeleteConfirm(false);

            }

          }}
        >

          <div
            className="sf-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            {/* HEADER */}

            <div className="sf-modal-header">

              <div>

                <span className="sf-modal-eyebrow">
                  REGISTRAR RECORD
                </span>

                <h2>
                  View Details
                </h2>

              </div>

              <button
                type="button"
                className="sf-modal-close"
                onClick={() => {

                  if (!deleting) {

                    setSelectedPerson(null);
                    setShowDeleteConfirm(false);

                  }

                }}
              >

                <FiX />

              </button>

            </div>


            {/* PROFILE */}

            <div className="sf-modal-profile">

              <div className="sf-modal-avatar">

                {getProfileImage(
                  selectedPerson.profile_pic
                ) ? (

                  <img
                    src={getProfileImage(
                      selectedPerson.profile_pic
                    )}
                    alt={
                      selectedPerson.full_name
                    }
                  />

                ) : (

                  <div className="sf-avatar-fallback">

                    {getInitials(
                      selectedPerson.full_name
                    )}

                  </div>

                )}

              </div>


              <div>

                <h3>
                  {selectedPerson.full_name ||
                    "Unnamed User"}
                </h3>

                <span
                  className={`sf-role ${
                    selectedPerson.role ||
                    "unknown"
                  }`}
                >

                  <span className="sf-role-dot" />

                  {selectedPerson.role
                    ? selectedPerson.role
                        .charAt(0)
                        .toUpperCase() +
                      selectedPerson.role.slice(1)
                    : "Unknown"}

                </span>

                <p className="sf-modal-email">
                  {selectedPerson.email}
                </p>

              </div>

            </div>


            {/* REGISTRAR INFORMATION */}

            <div className="sf-status-section">

              <h4>
                REGISTRAR INFORMATION
              </h4>


              <div className="sf-status-item">

                <div>

                  <strong>
                    Department / Program
                  </strong>

                  <span>
                    {selectedPerson.department_program ||
                      "Not specified"}
                  </span>

                </div>

              </div>


              <div className="sf-status-item">

                <div>

                  <strong>
                    Position
                  </strong>

                  <span>
                    {selectedPerson.position ||
                      "Not specified"}
                  </span>

                </div>

              </div>


              <div className="sf-status-item">

                <div>

                  <strong>
                    Batch
                  </strong>

                  <span>
                    {selectedPerson.batch ||
                      "Not specified"}
                  </span>

                </div>

              </div>


              <div className="sf-status-item">

                <div>

                  <strong>
                    Batch Name
                  </strong>

                  <span>
                    {selectedPerson.batch_name ||
                      "Not specified"}
                  </span>

                </div>

              </div>

            </div>


            {/* ACCOUNT STATUS */}

            <div className="sf-status-section">

             

              {selectedPerson.user_id && (

                <>

                  <div className="sf-status-item">

                    <div>

                      <strong>
                        Profile
                      </strong>

                      <span>
                        {selectedPerson.profile_complete
                          ? "Profile information is complete."
                          : "Profile information is incomplete."}
                      </span>

                    </div>

                    <span
                      className={`sf-status-badge ${
                        selectedPerson.profile_complete
                          ? "complete"
                          : "pending"
                      }`}
                    >

                      {selectedPerson.profile_complete
                        ? "Complete"
                        : "Incomplete"}

                    </span>

                  </div>


                  <div className="sf-status-item">

                    <div>

                      <strong>
                        Memories
                      </strong>

                      <span>

                        {Number(
                          selectedPerson.memory_count || 0
                        )}{" "}

                        {Number(
                          selectedPerson.memory_count || 0
                        ) === 1
                          ? "memory submitted"
                          : "memories submitted"}

                      </span>

                    </div>

                    <span
                      className={`sf-status-badge ${
                        Number(
                          selectedPerson.memory_count || 0
                        ) > 0
                          ? "complete"
                          : "pending"
                      }`}
                    >

                      {Number(
                        selectedPerson.memory_count || 0
                      ) > 0
                        ? "Submitted"
                        : "No Memories"}

                    </span>

                  </div>


                  <div className="sf-status-item">

                    <div>

                      <strong>
                        Yearbook Message
                      </strong>

                      <span>

                        {selectedPerson.message_complete
                          ? "Message has been submitted."
                          : "No yearbook message yet."}

                      </span>

                    </div>

                    <span
                      className={`sf-status-badge ${
                        selectedPerson.message_complete
                          ? "complete"
                          : "pending"
                      }`}
                    >

                      {selectedPerson.message_complete
                        ? "Completed"
                        : "Not Completed"}

                    </span>

                  </div>


                  <div className="sf-status-item">

                    <div>

                      <strong>
                        Yearbook Status
                      </strong>

                      <span>

                        {selectedPerson.yearbook_status ||
                          "Not available"}

                      </span>

                    </div>

                    <span
                      className={`sf-status-badge ${
                        selectedPerson.yearbook_status ===
                        "Included"
                          ? "complete"
                          : "pending"
                      }`}
                    >

                      {selectedPerson.yearbook_status ||
                        "Not Included"}

                    </span>

                  </div>

                </>

              )}

            </div>


            {/* DELETE */}

            {showDeleteConfirm ? (

              <div className="sf-delete-confirm">

                <div className="sf-delete-icon">
                  <FiTrash2 />
                </div>

                <div>

                 <h4>
  {selectedPerson.user_id
    ? "Delete User Account?"
    : "Delete Unactivated Record?"}
</h4>

<p>
  Are you sure you want to delete{" "}
  <strong>{selectedPerson.full_name}</strong>?
</p>

<p className="sf-delete-warning">
  {selectedPerson.user_id
    ? "This permanently deletes the user's account and associated records, including their profile, memories, posts, comments, reactions, notifications, and registrar record."
    : "This permanently removes the person's registrar record. They will no longer appear in the registered student and faculty directory."}
  {" "}
  <strong>This action cannot be undone.</strong>
</p>

                </div>


                <div className="sf-delete-actions">

                  <button
                    type="button"
                    className="sf-cancel-delete"
                    onClick={() =>
                      setShowDeleteConfirm(false)
                    }
                    disabled={deleting}
                  >
                    Cancel
                  </button>


                  <button
                    type="button"
                    className="sf-confirm-delete"
                    onClick={handleDeleteUser}
                    disabled={deleting}
                  >

                    <FiTrash2 />

{deleting
  ? "Deleting..."
  : selectedPerson.user_id
    ? "Delete Account"
    : "Delete Registrar Record"}

                  </button>

                </div>

              </div>

            ) : (


<div className="sf-modal-footer">
  <button
    type="button"
    className="sf-delete-user-btn"
    onClick={() => setShowDeleteConfirm(true)}
    disabled={deleting}
  >
    <FiTrash2 />
    {selectedPerson.user_id
      ? "Delete Account"
      : "Delete Registrar Record"}
  </button>

  <button
    type="button"
    className="sf-close-btn"
    onClick={() => {
      setSelectedPerson(null);
      setShowDeleteConfirm(false);
    }}
  >
    Close
  </button>
</div>


            )}

          </div>

        </div>

      )}

    </div>
  );
}

export default StudentsFaculty;